<script setup lang="ts">
import { RouterLink } from 'vue-router'
</script>

<template>
    <!-- <p><RouterLink :to="{ name: 'home' }">Tilbage</RouterLink></p> -->
    <main class="container-fluid main">
        <slot></slot>
    </main>
</template>
<style lang="scss" scoped>
.main {
    background: $white;
    min-height: 100vh;
}
</style>
